import { render, staticRenderFns } from "./OrticPagination.vue?vue&type=template&id=1ce40352&"
import script from "./OrticPagination.vue?vue&type=script&lang=js&"
export * from "./OrticPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports